import { usersTokenTemplate } from './users-token.template.js';
import { UsersTokenService } from './users-token.services.js';

export class UsersTokenComponent {
  constructor(container) {
    this.container = container;

    this.state = {
      firstname: '',
      lastname: '',
      email: '',
      purpose: '',
      loading: false,
      status: null, // 'success' | 'error' | 'exists'
    };

    this.render();
  }

  setState(newState) {
    this.state = { ...this.state, ...newState };
    this.render();
  }

  async handleSubmit(event) {
    event.preventDefault();

    const formData = new FormData(event.target);

    const firstname = formData.get('firstname');
    const lastname = formData.get('lastname');
    const email = formData.get('email');
    const purpose = formData.get('purpose');

    this.setState({
      firstname,
      lastname,
      email,
      purpose,
      loading: true,
      status: null,
    });

    try {
      const response = await UsersTokenService.createUser({
        firstname,
        lastname,
        email,
        purpose,
      });

      if (response.success) {
        this.setState({
          status: 'success',
          loading: false,
        });
      } else if (response.exists) {
        this.setState({
          status: 'exists',
          loading: false,
        });
      } else {
        this.setState({
          status: 'error',
          loading: false,
        });
      }
    } catch (error) {
      this.setState({
        status: 'error',
        loading: false,
      });
    }
  }

  bindEvents() {
    const form = this.container.querySelector('#users-token-form');
    if (form) {
      form.addEventListener('submit', this.handleSubmit.bind(this));
    }
  }

  render() {
    this.container.innerHTML = usersTokenTemplate(this.state);
    this.bindEvents();
  }
}
